import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as h } from "../../../../IconBase-CxZyIWw2.js";
const o = e((s, a) => /* @__PURE__ */ l.jsx(
  h,
  {
    ref: a,
    ...s,
    image: (r) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...r,
        children: [
          /* @__PURE__ */ l.jsxs(
            "mask",
            {
              id: "mask0_2974_4180",
              width: 32,
              height: 22,
              x: 8,
              y: 13,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: [
                /* @__PURE__ */ l.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M30.072 23.116v-3.732L26.7 22.82l.289-6.776L24 19.089l-2.602-2.651v5.892l-3.085-3.142v3.633h-3.662l5.976 6.09 1.253-.491v3.634h4.722V28.42l1.253.589 5.784-5.893zm-2.506 4.42-2.12-.982v4.321h-2.314v-4.223l-2.12.884-3.373-3.438h1.927v-1.866l3.085 3.143v-5.893L24 20.857l1.639-1.67-.29 6.68 3.47-3.537v2.063h1.832z"
                  }
                ),
                /* @__PURE__ */ l.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M8 13v22h32V13zm25.928 1.179v19.544H14.554V14.18zm-24.771 0H13.3v19.544H9.157zm29.686 19.544h-3.759V14.18h3.76z"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ l.jsx("g", { mask: "url(#mask0_2974_4180)", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0-.247h48v48.911H0z" }) })
        ]
      }
    )
  }
));
o.displayName = "AgencyFlagCanadaIcon";
export {
  o as AgencyFlagCanadaIcon,
  o as default
};
//# sourceMappingURL=index.js.map
